<template>
    <div class="supplier-payable-report-container">
        <div class="t-top-bar">
            <div class="report-op">
              <el-select id="supplierSelect" clearable filterable class="search-input" v-model="supplierId" placeholder="选择客户">
                <el-option v-for="(val,key) in supplierList" :key="key" :label="val.supplierName" :value="val.supplierId"></el-option>
              </el-select>
              <el-date-picker v-model="selectTime" type="datetimerange"
                              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                              align="right"></el-date-picker>
            </div>
          <div class="report-op"><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
          <div class="report-op"><el-button style="margin: 0" type="primary"  @click="print">打印</el-button></div>
          <div class="report-op"><i class="el-icon-download l-add-buttion" @click="exportExcel"></i></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%"  height="640" v-loading="listLoading">
          <el-table-column prop="supplier_name" label="供应商" width="100">
            <template slot-scope="scope">
              <div class="clickable" @click="supplierClick(scope.row)">{{scope.row.supplier_name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="期初余额" width="100">
            <template slot-scope="scope">
<!--              <el-input type="number" @blur="inputblur(scope.row)" v-model="scope.row.startBalance" v-if="scope.row.input"></el-input>-->
<!--              <div @dblclick="divclick(scope.row)" v-if="scope.row.div">{{scope.row.startBalance}}</div>-->
              {{(scope.row.startBalance+scope.row.total_price_b-scope.row.amount_b).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column prop="" width="180" label="本次发生">
            <el-table-column prop="" label="增项">
              <el-table-column prop="total_price" label="原料增项"></el-table-column>
              <el-table-column prop="" label="辅料增项">
                <template slot-scope="scope">0</template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="amount" label="付款">
              <template slot-scope="scope">
                <div class="clickable" @click="payClick(scope.row)">{{scope.row.amount}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="" label="余额">
            <template slot-scope="scope">{{(scope.row.startBalance+scope.row.total_price_b-scope.row.amount_b+scope.row.total_price-scope.row.amount).toFixed(2) }}</template>
          </el-table-column>
        </el-table>
      <el-dialog title="供货数据明细" :visible.sync="supplierDialogVisiable"  width="650px">
        <el-table :data="supplierSumTableData" border style="width: 100%"  max-height="350">
          <el-table-column type="index"  label="序号" width="50"> </el-table-column>
          <el-table-column prop="supplier_name" label="日期">
            <template slot-scope="scope">
              {{scope.row.year}}-{{scope.row.month}}-{{scope.row.day}}
            </template>
          </el-table-column>
          <el-table-column prop="supplier_name" label="供货商"></el-table-column>
          <el-table-column prop="total_price" label="金额"></el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog title="付款记录" :visible.sync="payDialogVisiable"
                 @close="payDialogCloseHandler"  width="750px">
        <el-table :data="payTableData" border style="width: 100%" max-height="350">
          <el-table-column type="index"  label="序号" width="50"> </el-table-column>
          <el-table-column prop="payTime" label="付款日期" width="180">
            <template slot-scope="scope">
              {{scope.row.payTime | formateTime}}
            </template>
          </el-table-column>
          <el-table-column prop="supplierName" label="收款人"></el-table-column>
          <el-table-column prop="subject" label="科目"></el-table-column>
          <el-table-column prop="amount" label="付款金额"></el-table-column>
          <el-table-column prop="append" label="摘要"></el-table-column>
        </el-table>
      </el-dialog>

    </div>
</template>

<script>
    import { getSupplierList } from '../../api/supplier'
    import { tableDataToExcelSample, dataprint} from '../../util/util'
    import { getSupplayPayBillItemList,getSupplierPayable,getSupplierSum} from '../../api/supplyPayBill'
    import localCache from "../../util/localCache";
    import {addProduction, updateProduction} from "@/api/prouction";
    export default {
        name: "supplierStatisticsReportContainer",
        data(){
            return {
                listLoading: false,
                tableHead: [],
                tableData: [],
                selectTime: '',
                keyword: '',
                searchDepart:'',
                treeData: [],
                priceType:'',
                supplierId: '',
                supplierList: [],
              payDialogVisiable: false,
              payTableData: [],
              addPayDialogVisiable: false,
              addForm:{
                payTime:'',
                supplyTime:'',
                payee:'',
                subject:'',
                amount:'',
                append:'',
              },
              formLabelWidth: '120px',
              supplierSumTableData:[],
              supplierDialogVisiable:false,
            }
        },
        mounted(){
          let now = new Date()
          let end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0);
          this.selectTime = [end,now]

          this.getSupplierList_();
        },
        methods: {
          inputblur(row){
            row.div=true
            row.input=false
          },
          divclick(row){
            row.div=false
            row.input=true
          },
          supplierClick(row){
            this.supplierDialogVisiable = true
            this.supplierSumTableData=[]
            getSupplierSum({
              customerId: localCache.getCurrentCustomerId(),
              beginTime: parseInt(this.selectTime[0].getTime()/1000),
              endTime: parseInt(this.selectTime[1].getTime()/1000),
              supplierId:row.supplier_id
            }).then((res)=>{
              if(res.errorcode==0){
                let sum = 0
                res.data.forEach((t)=>{
                  sum += t.total_price
                })

                this.supplierSumTableData = res.data
                if(res.data.length>0){
                  this.supplierSumTableData.push({
                    'supplier_name': '合计',
                    'total_price': sum.toFixed(2)
                  })
                }
              }
            })
          },
          payDialogCloseHandler(){

          },
          payClick(row){
            this.payDialogVisiable=true
            let param = {
              customerId: localCache.getCurrentCustomerId(),
              beginTime: parseInt(this.selectTime[0].getTime()/1000),
              endTime: parseInt(this.selectTime[1].getTime()/1000),
              supplierId:row.supplier_id
            }
            getSupplayPayBillItemList(param).then((res)=>{
              if(res.errorcode == 0){
                this.payTableData = res.data
              }
            })
          },
          getSupplierList_(){
            let param = {
              customerId: localCache.getCurrentCustomerId(),
            }
            getSupplierList(param).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.supplierList = res.data
              }
            }).catch(() => {
            })
          },
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容
            let selectSupplier = document.getElementById('supplierSelect').value
            let date1 = new Date(this.selectTime[0])
            let time1 = `${date1.getFullYear()}年${date1.getMonth()+1}月${date1.getDate()}日`
            let date2 = new Date(this.selectTime[1])
            let time2 = `${date2.getFullYear()}年${date2.getMonth()+1}月${date2.getDate()}日`
            let t = `<tr>
                        <td>查询日段</td>
                        <td>统计时段：</td>
                        <td colspan="2">${time1}~${time2}</td>
                        <td>供应商名称</td>
                        <td></td>
                        </tr>`

            dataprint(t+printHTML)
          },
            exportExcel(){
              // let date = new Date(this.selectTime)
              let title = `应付报表`
              let str = document.querySelector('.el-table__header').innerHTML
              let body = document.querySelector('.el-table__body').innerHTML
              let selectSupplier = document.getElementById('supplierSelect').value
              let date1 = new Date(this.selectTime[0])
              let time1 = `${date1.getFullYear()}年${date1.getMonth()+1}月${date1.getDate()}日`
              let date2 = new Date(this.selectTime[1])
              let time2 = `${date2.getFullYear()}年${date2.getMonth()+1}月${date2.getDate()}日`
              let t = `<tr>
                        <td>查询日段</td>
                        <td>统计时段：</td>
                        <td colspan="2">${time1}~${time2}</td>
                        <td>供应商名称</td>
                        <td></td>
                        </tr>`

              tableDataToExcelSample(t+str+body,title)
            },
            search(){
                this.getRecordList_()
            },
          getRecordList_(){
                if(!this.selectTime){
                    this.$message.error('请选择时间')
                    return
                }
                this.listLoading = true
                let departmentId = ''
                if(this.searchDepart){
                    departmentId = this.searchDepart[this.searchDepart.length-1]
                }
                console.log(this.selectTime)
                let param = {
                  customerId: localCache.getCurrentCustomerId(),
                  beginTime: parseInt(this.selectTime[0].getTime()/1000),
                  endTime: parseInt(this.selectTime[1].getTime()/1000),
                  supplierId:this.supplierId
                }
            getSupplierPayable(param).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                      res.data.forEach((t)=>{
                        t.input=false
                        t.div=true
                      })
                        this.tableData = res.data
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            datasort(data){
              return data.sort((t1,t2)=>{
                let r = t1.spec_name.replace('/','') > t2.spec_name.replace('/','')
                if(r){
                  return 1
                }else{
                  return -1;
                }
              })
            },
        }
    }
</script>

<style lang="scss">
    .supplier-payable-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
      .clickable{
        color:blue;
        cursor: pointer;
      }
    }

</style>
